/**
 * 平台菜单
 */

export default [
  {
    label: 'DEMO',
    icon: 'icon-caidan',
    permission:'wage_demo_menu',
    id:7,
    children: [
      {
        label: 'CRUD',
        icon: 'icon-yonghu',
        path: '/serve/table',
        permission: 'wage_demo_menu',
        id:7-1,
      },
      // {
      //   label: '人事云菜单连接-休假设置',
      //   icon: 'icon-yonghu',
      //   path: '/vacnstandard/toindex.action',
      //   permission: 'hrcloud_atnd_set',
      //   id:7-1,
      // },
      // {
      //   label: '人事云菜单连接-机构管理',
      //   icon: 'icon-yonghu',
      //   path: '/org/toOrgPage.action',
      //   permission: 'hrcloud_atnd_approve',
      //   id:7-1,
      // },
      {
        path: '/serve/dynamicTable',
        label: '动态表单',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-2
      },

      {
        path: '/table',
        label: '表格内编辑',
        icon: 'icon-yonghu',
        permission: 'wage_demo_menu',
        id:7-3
      },
      {
        path: '/tabs',
        label: '动态页签',
        icon: 'icon-yonghu',
        permission: 'wage_demo_menu',
        id:7-5
      },
      {
        path: '/serve/groupTable',
        label: '多级列头',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-6
      },
      // {
      //   path: '/form/customerCenter',
      //   label: '客户中心',
      //   permission: 'wage_demo_menu',
      //   icon: 'icon-yonghu',
      //   id:7-8
      // },
      {
        path: '/socket/msg',
        label: '消息驱动',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id: 7-9
      },
      {
        path: '/batchParent',
        label: '批量导入',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-8
      },
      // {
      //   path: '/ceshi',
      //   label: '测试',
      //   permission: 'wage_demo_menu',
      //   icon: 'icon-yonghu',
      //   id:7-8
      // },
      {
        path: '/websocket',
        label: 'WebSocket测试',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-10
      },
			{
				path: '/VueTour',
				label: '指引',
				permission: 'wage_demo_menu',
				icon: 'icon-yonghu',
				id:7-11
			},
    ],
  },
  {
    label: '业务静态页面',
    icon: 'icon-caidan',
    permission:'wage_wage_menu',
    id:8,
    children: [
      {
        path: '/salary_template',
        label: '薪资模板',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-11
      },
      {
        path: '/salarySet',
        label: '薪酬设置',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-12
      },
      {
        path: '/formUpload',
        label: '表格上传',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-13
      },
      {
        path: '/approval',
        label: '工资审批',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-14
      },
      {
        path: '/payment',
        label: '付款通知单',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-15
      },
      {
        path: '/paymentWage',
        label: '工资发放',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-16
      },
      {
        path: '/tax',
        label: '个税申报',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-17
      },
      {
        path: '/demo/wageHistory',
        label: '工资历史',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-18
      },
      {
        path: '/payrollSettings',
        label: '工资单设置',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-19
      },
      {
        path: '/treeSelect',
        label: '树形选择框',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-20
      },
      {
        path: '/dataImport',
        label: '数据导入',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-20
      },
      {
        path: '/customHeader?a=123',
        label: '自定义表头',
        permission: 'wage_demo_menu',
        icon: 'icon-yonghu',
        id:7-20
      },
    ],
  },
];

